import { ECookiesActionTypes, TSetHideOnboardingByCookie } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const setHideOnboardingByCookie: () => TSetHideOnboardingByCookie =
  actionGenerator<ECookiesActionTypes.SetHideOnboardingByCookie>(ECookiesActionTypes.SetHideOnboardingByCookie);
